import { takeEvery, call, all, fork, put } from "redux-saga/effects"
import { getReportProperties, getBrochure, getReportPropertiesDiscontinued, getBrochureList } from "../../helpers/backend_helper"
import { GET_BROCHURE, GET_BROCHURE_LIST, GET_PROPERTIES_DISCONTINUED, GET_REPORT_PROPERTIES, getBrochureListSuccess, getBrochureSuccess, getReportPropertiesDiscontinuedSuccess } from "./actions"
import toastr from "toastr";
import { showPreloader } from "store/actions";


/**
 * Get report properties
 */
function* fetchReportProperties({ payload: filter }) {
  
    try {
      const response = yield call(getReportProperties, filter)
      // Crear un enlace para descargar el archivo Excel
      const link = document.createElement('a')
      link.href = response // Ya es un objeto URL creado por postAndGetExcel
      link.setAttribute('download', `reporte_propiedades_${new Date().toISOString().split('T')[0]}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      // Notificar al usuario que la descarga ha comenzado
      toastr.success("El reporte se está descargando")
      
    } catch (error) {
      toastr.error("Error al generar el reporte")
      console.error(error)
      yield put(showPreloader(false))
    }
}

function* onGetReportPropertiesDiscontinued({ payload: filter }) {
  yield put(getReportPropertiesDiscontinuedSuccess(null))
  yield put(showPreloader(true))
    try {
      const response = yield call(getReportPropertiesDiscontinued, filter)
      yield put(getReportPropertiesDiscontinuedSuccess(response))
      toastr.success("Se ha generado el reporte")
    } catch (error) {
      console.log(error)
      toastr.error(response?.message || "Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
    finally {
      yield put(showPreloader(false))
    }
}

function* onGetBrochure({ payload: filter }) {
  yield put(getBrochureSuccess(null))
  yield put(showPreloader(true))
    try {
      const response = yield call(getBrochure, filter)
      //yield put(getBrochureSuccess(response))
      if(response.success) {
        toastr.success(response.message)
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
    finally {
      yield put(showPreloader(false))
    }
}

function* onGetBrochureList({ payload: filter }) {
  yield put(getBrochureListSuccess([]))
  yield put(showPreloader(true))
    try {
      const response = yield call(getBrochureList, filter)
      if(response.success) {
        toastr.success(response.message)
        yield put(getBrochureListSuccess(response.data))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
    finally {
      yield put(showPreloader(false))
    }
}


export function* watchReportsSaga() {
    yield takeEvery(GET_REPORT_PROPERTIES, fetchReportProperties)
    yield takeEvery(GET_BROCHURE, onGetBrochure)
    yield takeEvery(GET_PROPERTIES_DISCONTINUED, onGetReportPropertiesDiscontinued)
    yield takeEvery(GET_BROCHURE_LIST, onGetBrochureList)
}

function* reportsSaga() {
    yield all([fork(watchReportsSaga)]);
}

export default reportsSaga;
